import { api } from './client'
import type { components } from './generated/schema'

// Thư viện ảnh bán lẻ (Bán lẻ › Thư viện ảnh) + ô chọn ảnh dùng chung
// MediaPicker. File công khai /uploads/shop/…; ảnh jpeg/png/webp ≤ 10 MB,
// video mp4 ≤ 50 MB.

export type ShopMedia = components['schemas']['ShopMedia']
export type ShopMediaRef = components['schemas']['ShopMediaRef']
export type ShopMediaUploadError = components['schemas']['ShopMediaUploadError']
export type ShopMediaInput = components['schemas']['ShopMediaInput']
export type ShopMediaKind = 'image' | 'video'

export interface ShopMediaListParams {
    q?: string
    kind?: ShopMediaKind
    page?: number
    per_page?: number
}

export interface ShopMediaUploadResult {
    items: ShopMedia[]
    errors: ShopMediaUploadError[]
}

/** Loại file nhận khi tải lên (khớp server). */
export const MEDIA_ACCEPT = {
    image: 'image/jpeg,image/png,image/webp',
    video: 'video/mp4',
    all: 'image/jpeg,image/png,image/webp,video/mp4',
} as const

export const isVideo = (m: Pick<ShopMedia, 'mime'>) =>
    m.mime.startsWith('video/')

export const shopMediaApi = {
    list: (params: ShopMediaListParams) =>
        api.get<ShopMedia[]>('/shop-admin/media', { params }),
    upload: (
        files: File[],
        options?: {
            signal?: AbortSignal
            onUploadProgress?: (pct: number) => void
        },
    ) => {
        const form = new FormData()
        for (const f of files) form.append('files', f)
        return api.post<ShopMediaUploadResult>(
            '/shop-admin/media',
            form,
            options,
        )
    },
    update: (id: string, input: ShopMediaInput) =>
        api.patch<ShopMedia>(`/shop-admin/media/${id}`, input),
    remove: (id: string) => api.delete<void>(`/shop-admin/media/${id}`),
    usage: (id: string) =>
        api.get<ShopMediaRef[]>(`/shop-admin/media/${id}/usage`),
}
